import axios from '@octagon/axios';
import { apiInstance } from './apiInstance';

export const fetchClpEligibilityData = async (): Promise<any> => {
  try {
    const response = await apiInstance.post('/get-upload-history', {
      headers: {
        'Content-Type': 'application/json',
      }
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log('Axios error:', error);
      throw new Error('Error fetching data');
    } else {
      console.log('Non-axios error:', error);
      throw error;
    }
  }
};
